import { FiEdit2, FiTrash2 } from "react-icons/fi";
import { StoreGroup } from "../../../types/app/storeGroupsTypes";
import StoreTypeAvatar from "./StoreTypeAvatar";

interface StoreTypeRowProps {
  group: StoreGroup;
  onEdit: (group: StoreGroup) => void;
  onDelete: (group: StoreGroup) => void;
  isDeleting?: boolean;
}

const StoreTypeRow = ({ group, onEdit, onDelete, isDeleting = false }: StoreTypeRowProps) => {
  return (
    <tr className="store-type-row">
      <td className="checkbox-cell">
        <label className="checkbox-container" aria-label="Store type selection">
          <input type="checkbox" disabled />
          <span className="checkmark"></span>
        </label>
      </td>
      <td className="store-type-name-cell">
        <div className="store-type-details">
          <StoreTypeAvatar group={group} />
          <div className="store-type-copy">
            <div className="store-type-name">{group.name || "-"}</div>
            <div className="store-type-subtext">Use edit to manage description and image</div>
          </div>
        </div>
      </td>
      <td className="store-type-empty">
        <span className="muted-value">-</span>
      </td>
      <td className="store-type-empty">
        <span className="muted-value">-</span>
      </td>
      <td className="store-type-actions">
        <button
          type="button"
          aria-label={`Edit ${group.name || "store type"}`}
          onClick={() => onEdit(group)}
        >
          <FiEdit2 size={16} />
        </button>
        <button
          type="button"
          disabled={isDeleting}
          aria-label={`Delete ${group.name || "store type"}`}
          className="delete-action"
          onClick={() => onDelete(group)}
        >
          {isDeleting ? <span className="action-loading-dot"></span> : <FiTrash2 size={16} />}
        </button>
      </td>
    </tr>
  );
};

export default StoreTypeRow;
